export const COMPLETE_SUBSCRIPTION_REQUEST = "COMPLETE_SUBSCRIPTION_REQUEST";
export const COMPLETE_SUBSCRIPTION_SUCCESS = "COMPLETE_SUBSCRIPTION_SUCCESS";
export const COMPLETE_SUBSCRIPTION_ERROR = "COMPLETE_SUBSCRIPTION_ERROR";

export const completeSubscriptionRequest = (payload) => ({
  type: COMPLETE_SUBSCRIPTION_REQUEST,
  ...payload,
});

export const completeSubscriptionSuccess = () => ({
  type: COMPLETE_SUBSCRIPTION_SUCCESS,
});

export const completeSubscriptionError = () => ({
  type: COMPLETE_SUBSCRIPTION_ERROR,
});



// WEBPACK FOOTER //
// ./src/pages/complete-subscription/actions.js